window.LED_MIRROR_DATA = {
  "styleOrder": [
    "Liberty",
    "Lexington",
    "Lincoln",
    "Largo",
    "Lakeland",
    "Linden",
    "Laurel"
  ],
  "styles": {
    "Liberty": {
      "2PC": [
        {
          "label": "24\" × 24\"",
          "w": 24,
          "l": 24,
          "shape": "rect",
          "handle": "liberty-front-lighted-24x24",
          "vid": "45355189502061",
          "qty": 29
        },
        {
          "label": "20\" × 28\"",
          "w": 20,
          "l": 28,
          "shape": "rect",
          "handle": "liberty-front-lighted-20x28",
          "vid": "45355189469293",
          "qty": 17
        },
        {
          "label": "24\" × 32\"",
          "w": 24,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-24x32",
          "vid": "45355189698669",
          "qty": 47
        },
        {
          "label": "28\" × 32\"",
          "w": 28,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-28x32",
          "vid": "45355190943853",
          "qty": 20
        },
        {
          "label": "32\" × 32\"",
          "w": 32,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-32x32",
          "vid": "41633514094701",
          "qty": 24
        },
        {
          "label": "36\" × 32\"",
          "w": 36,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-36x32",
          "vid": "45075623870573",
          "qty": 2
        },
        {
          "label": "40\" × 32\"",
          "w": 40,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-40x32",
          "vid": "45355194876013",
          "qty": 4
        },
        {
          "label": "44\" × 32\"",
          "w": 44,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-44x32",
          "vid": "45355195105389",
          "qty": 5
        },
        {
          "label": "48\" × 32\"",
          "w": 48,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-48x32",
          "vid": "45355196121197",
          "qty": 27
        },
        {
          "label": "24\" × 36\"",
          "w": 24,
          "l": 36,
          "shape": "rect",
          "handle": "led-mirror-front-lighted-24-x-37",
          "vid": "45075623837805",
          "qty": 44
        },
        {
          "label": "30\" × 36\"",
          "w": 30,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-30x36",
          "vid": "45355193139309",
          "qty": 8
        },
        {
          "label": "32\" × 36\"",
          "w": 32,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-32x36",
          "vid": "45355194351725",
          "qty": 15
        },
        {
          "label": "40\" × 36\"",
          "w": 40,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-40x36",
          "vid": "45355194908781",
          "qty": 6
        },
        {
          "label": "48\" × 36\"",
          "w": 48,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-48x36",
          "vid": "45355196350573",
          "qty": 26
        },
        {
          "label": "56\" × 36\"",
          "w": 56,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-56x36",
          "vid": "45355197431917",
          "qty": 23
        },
        {
          "label": "60\" × 36\"",
          "w": 60,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-60x36",
          "vid": "45075625246829",
          "qty": 55
        },
        {
          "label": "24\" × 40\"",
          "w": 24,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-24x40",
          "vid": "45355189796973",
          "qty": 16
        },
        {
          "label": "28\" × 40\"",
          "w": 28,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-28x40",
          "vid": "45355192057965",
          "qty": 9
        },
        {
          "label": "32\" × 40\"",
          "w": 32,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-32x40",
          "vid": "45355194450029",
          "qty": 5
        },
        {
          "label": "36\" × 40\"",
          "w": 36,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-36x40",
          "vid": "40834569830509",
          "qty": 29
        },
        {
          "label": "44\" × 40\"",
          "w": 44,
          "l": 40,
          "shape": "rect",
          "handle": "front-lit-led-bathroom-mirror-40-x-44-rectangle",
          "vid": "40691163332717",
          "qty": 1
        },
        {
          "label": "48\" × 40\"",
          "w": 48,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-48x40",
          "vid": "45355196678253",
          "qty": 6
        },
        {
          "label": "56\" × 40\"",
          "w": 56,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-56x40",
          "vid": "45355197726829",
          "qty": 21
        },
        {
          "label": "60\" × 40\"",
          "w": 60,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-60x40",
          "vid": "45355197988973",
          "qty": 27
        },
        {
          "label": "48\" × 44\"",
          "w": 48,
          "l": 44,
          "shape": "rect",
          "handle": "liberty-front-lighted-48x44",
          "vid": "45075625017453",
          "qty": 9
        },
        {
          "label": "24\" × 48\"",
          "w": 24,
          "l": 48,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-24-x-48-rectangular-wall-mounted",
          "vid": "40834523693165",
          "qty": 14
        },
        {
          "label": "28\" × 48\"",
          "w": 28,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-28x48",
          "vid": "45355192582253",
          "qty": 17
        },
        {
          "label": "32\" × 48\"",
          "w": 32,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-32x48",
          "vid": "40834563801197",
          "qty": 18
        },
        {
          "label": "36\" × 48\"",
          "w": 36,
          "l": 48,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-36-x-48-rectangular-wall-mounted",
          "vid": "40834572877933",
          "qty": 0
        },
        {
          "label": "40\" × 48\"",
          "w": 40,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-40x48",
          "vid": "40834589917293",
          "qty": 0
        },
        {
          "label": "44\" × 48\"",
          "w": 44,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-44x48",
          "vid": "45355195334765",
          "qty": 10
        },
        {
          "label": "48\" × 48\"",
          "w": 48,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-48x48",
          "vid": "45355196907629",
          "qty": 34
        },
        {
          "label": "40\" × 60\"",
          "w": 40,
          "l": 60,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-60-x-40-rectangular-wall-mounted",
          "vid": "40834607644781",
          "qty": 0
        },
        {
          "label": "22\" × 62\"",
          "w": 22,
          "l": 62,
          "shape": "rect",
          "handle": "liberty-front-lighted-22x62",
          "vid": "40834511077485",
          "qty": 5
        },
        {
          "label": "36\" × 72\"",
          "w": 36,
          "l": 72,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-36-x-72-rectangular-wall-mounted",
          "vid": "40834578514029",
          "qty": 1
        }
      ],
      "1PC": [
        {
          "label": "28\" × 32\"",
          "w": 28,
          "l": 32,
          "shape": "rect",
          "handle": "liberty-front-lighted-28x32-1pc",
          "vid": "45355191205997",
          "qty": 6
        },
        {
          "label": "24\" × 36\"",
          "w": 24,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-24x36-1pc",
          "vid": "45350856851565",
          "qty": 89
        },
        {
          "label": "28\" × 36\"",
          "w": 28,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-28x36-1pc",
          "vid": "45355191763053",
          "qty": 26
        },
        {
          "label": "42\" × 36\"",
          "w": 42,
          "l": 36,
          "shape": "rect",
          "handle": "liberty-front-lighted-42x36-1pc",
          "vid": "45355195072621",
          "qty": 0
        },
        {
          "label": "24\" × 40\"",
          "w": 24,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-24x40-1pc",
          "vid": "45355190124653",
          "qty": 9
        },
        {
          "label": "28\" × 40\"",
          "w": 28,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-28x40-1pc",
          "vid": "45355192320109",
          "qty": 13
        },
        {
          "label": "32\" × 40\"",
          "w": 32,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-32x40-1pc",
          "vid": "45355194515565",
          "qty": 0
        },
        {
          "label": "36\" × 40\"",
          "w": 36,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-36x40-1pc",
          "vid": "45355194679405",
          "qty": 12
        },
        {
          "label": "40\" × 40\"",
          "w": 40,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-40x40-1pc",
          "vid": "45355194974317",
          "qty": 5
        },
        {
          "label": "46\" × 40\"",
          "w": 46,
          "l": 40,
          "shape": "rect",
          "handle": "liberty-front-lighted-46x40-1pc",
          "vid": "45355195826285",
          "qty": 0
        },
        {
          "label": "40\" × 44\"",
          "w": 40,
          "l": 44,
          "shape": "rect",
          "handle": "liberty-front-lighted-40x44-1pc",
          "vid": "45355195007085",
          "qty": 3
        },
        {
          "label": "24\" × 48\"",
          "w": 24,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-24x48-13do",
          "vid": "45355190419565",
          "qty": 8
        },
        {
          "label": "28\" × 48\"",
          "w": 28,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-28x48-1pc",
          "vid": "45355192909933",
          "qty": 22
        },
        {
          "label": "32\" × 48\"",
          "w": 32,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-32x48-1pc",
          "vid": "45355194548333",
          "qty": 27
        },
        {
          "label": "36\" × 48\"",
          "w": 36,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-36x48-13do",
          "vid": "45355194777709",
          "qty": 0
        },
        {
          "label": "40\" × 48\"",
          "w": 40,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-front-lighted-40x48-1pc",
          "vid": "45355195039853",
          "qty": 4
        },
        {
          "label": "48\" × 48\"",
          "w": 48,
          "l": 48,
          "shape": "rect",
          "handle": "liberty-48x48-13do",
          "vid": "45355197169773",
          "qty": 10
        }
      ]
    },
    "Lexington": {
      "2PC": [
        {
          "label": "20\" × 28\"",
          "w": 20,
          "l": 28,
          "shape": "rect",
          "handle": "lexington-side-lighted-20x28",
          "vid": "45355198546029",
          "qty": 2
        },
        {
          "label": "30\" × 30\"",
          "w": 30,
          "l": 30,
          "shape": "rect",
          "handle": "lexington-side-lighted-30x30",
          "vid": "40834626125933",
          "qty": 1
        },
        {
          "label": "48\" × 32\"",
          "w": 48,
          "l": 32,
          "shape": "rect",
          "handle": "lexington-side-lighted-48x32",
          "vid": "45355201790061",
          "qty": 31
        },
        {
          "label": "24\" × 36\"",
          "w": 24,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-24x36",
          "vid": "45355199266925",
          "qty": 17
        },
        {
          "label": "28\" × 36\"",
          "w": 28,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-side-lighted-28x36",
          "vid": "41758422532205",
          "qty": 2
        },
        {
          "label": "32\" × 36\"",
          "w": 32,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-side-lighted-32x36",
          "vid": "41758440456301",
          "qty": 8
        },
        {
          "label": "36\" × 36\"",
          "w": 36,
          "l": 36,
          "shape": "rect",
          "handle": "side-lighted-led-bathroom-vanity-mirror-36-x-36-square-wall-mounted",
          "vid": "40834637889645",
          "qty": 0
        },
        {
          "label": "44\" × 36\"",
          "w": 44,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-side-lighted-44x36",
          "vid": "45355201462381",
          "qty": 15
        },
        {
          "label": "48\" × 36\"",
          "w": 48,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-side-lighted-48x36",
          "vid": "45355202510957",
          "qty": 49
        },
        {
          "label": "54\" × 36\"",
          "w": 54,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-side-lighted-54x36",
          "vid": "45355203788909",
          "qty": 14
        },
        {
          "label": "60\" × 36\"",
          "w": 60,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-side-lighted-60x36",
          "vid": "45355204378733",
          "qty": 22
        },
        {
          "label": "28\" × 40\"",
          "w": 28,
          "l": 40,
          "shape": "rect",
          "handle": "side-lighted-led-bathroom-vanity-mirror-28-x-40-rectangular-wall-mounted",
          "vid": "40836714168429",
          "qty": -3
        },
        {
          "label": "32\" × 40\"",
          "w": 32,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-side-lighted-32x40",
          "vid": "41758448025709",
          "qty": 4
        },
        {
          "label": "36\" × 40\"",
          "w": 36,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-side-lighted-36x40",
          "vid": "41633496891501",
          "qty": 12
        },
        {
          "label": "48\" × 40\"",
          "w": 48,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-side-lighted-48x40",
          "vid": "45355202838637",
          "qty": 2
        },
        {
          "label": "54\" × 40\"",
          "w": 54,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-side-lighted-54x40",
          "vid": "45355204116589",
          "qty": 10
        },
        {
          "label": "60\" × 40\"",
          "w": 60,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-side-lighted-60x40",
          "vid": "45355204608109",
          "qty": 16
        },
        {
          "label": "32\" × 44\"",
          "w": 32,
          "l": 44,
          "shape": "rect",
          "handle": "lexington-side-lighted-32x44",
          "vid": "45355199791213",
          "qty": 0
        },
        {
          "label": "36\" × 44\"",
          "w": 36,
          "l": 44,
          "shape": "rect",
          "handle": "side-lighted-led-bathroom-vanity-mirror-36-x-44-rectangular-wall-mounted",
          "vid": "40834644443245",
          "qty": 2
        },
        {
          "label": "48\" × 44\"",
          "w": 48,
          "l": 44,
          "shape": "rect",
          "handle": "lexington-side-lighted-48x44",
          "vid": "45355203100781",
          "qty": 4
        },
        {
          "label": "32\" × 48\"",
          "w": 32,
          "l": 48,
          "shape": "rect",
          "handle": "lexington-side-lighted-32x48",
          "vid": "45355199823981",
          "qty": 6
        },
        {
          "label": "40\" × 48\"",
          "w": 40,
          "l": 48,
          "shape": "rect",
          "handle": "side-lighted-led-bathroom-vanity-mirror-40-x-48-rectangular-wall-mounted",
          "vid": "40834648440941",
          "qty": 0
        },
        {
          "label": "48\" × 48\"",
          "w": 48,
          "l": 48,
          "shape": "rect",
          "handle": "side-lighted-led-bathroom-vanity-mirror-48-x-48-square-wall-mounted",
          "vid": "40834652799085",
          "qty": 16
        },
        {
          "label": "30\" × 60\"",
          "w": 30,
          "l": 60,
          "shape": "rect",
          "handle": "lexington-side-lighted-30x60",
          "vid": "45355199692909",
          "qty": 3
        },
        {
          "label": "22\" × 62\"",
          "w": 22,
          "l": 62,
          "shape": "rect",
          "handle": "lexington-side-lighted-22x62",
          "vid": "40834612527213",
          "qty": 2
        }
      ],
      "1PC": [
        {
          "label": "24\" × 36\"",
          "w": 24,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-24x36-13do",
          "vid": "45355199463533",
          "qty": 0
        },
        {
          "label": "32\" × 36\"",
          "w": 32,
          "l": 36,
          "shape": "rect",
          "handle": "lexington-32x36-13do",
          "vid": "45355199725677",
          "qty": 2
        },
        {
          "label": "28\" × 40\"",
          "w": 28,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-side-lighted-28x40-1pc",
          "vid": "45355199594605",
          "qty": 2
        },
        {
          "label": "32\" × 40\"",
          "w": 32,
          "l": 40,
          "shape": "rect",
          "handle": "lexington-32x40-13do",
          "vid": "45355199758445",
          "qty": 7
        },
        {
          "label": "28\" × 44\"",
          "w": 28,
          "l": 44,
          "shape": "rect",
          "handle": "lexington-side-lighted-28x44-1pc",
          "vid": "45355199660141",
          "qty": 7
        },
        {
          "label": "40\" × 48\"",
          "w": 40,
          "l": 48,
          "shape": "rect",
          "handle": "lexington-40x48-13do",
          "vid": "45355200675949",
          "qty": 2
        }
      ]
    },
    "Lincoln": {
      "2PC": [
        {
          "label": "24\" × 32\"",
          "w": 24,
          "l": 32,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-24-wide-x-32-tall-rectangular-vertical-led-bars-wall-mounted",
          "vid": "40834348122221",
          "qty": 0
        },
        {
          "label": "24\" × 36\"",
          "w": 24,
          "l": 36,
          "shape": "rect",
          "handle": "lincoln-front-lighted-24x36",
          "vid": "45355184226413",
          "qty": 14
        },
        {
          "label": "28\" × 36\"",
          "w": 28,
          "l": 36,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-28-wide-x-36-tall-rectangular-vertical-led-bars-wall-mounted",
          "vid": "40834380103789",
          "qty": 0
        },
        {
          "label": "48\" × 36\"",
          "w": 48,
          "l": 36,
          "shape": "rect",
          "handle": "lincoln-front-lighted-48x36",
          "vid": "45355185176685",
          "qty": 7
        },
        {
          "label": "36\" × 40\"",
          "w": 36,
          "l": 40,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-36-wide-x-40-tall-rectangular-vertical-led-bars-wall-mounted",
          "vid": "40834382168173",
          "qty": 4
        },
        {
          "label": "36\" × 48\"",
          "w": 36,
          "l": 48,
          "shape": "rect",
          "handle": "front-lighted-led-bathroom-vanity-mirror-36-wide-x-48-tall-rectangular-vertical-led-bars-wall-mounted",
          "vid": "40834384855149",
          "qty": 0
        }
      ],
      "1PC": [
        {
          "label": "36\" × 48\"",
          "w": 36,
          "l": 48,
          "shape": "rect",
          "handle": "lincoln-front-lighted-36x48-1pc",
          "vid": "45355184849005",
          "qty": 1
        }
      ]
    },
    "Largo": {
      "2PC": [
        {
          "label": "36\"",
          "w": 36,
          "l": 36,
          "shape": "round",
          "handle": "front-lighted-led-bathroom-vanity-mirror-36-x-36-round-wall-mounted",
          "vid": "40834405433453",
          "qty": 1
        },
        {
          "label": "40\"",
          "w": 40,
          "l": 40,
          "shape": "round",
          "handle": "largo-front-lighted-40x40",
          "vid": "40834409136237",
          "qty": 30
        },
        {
          "label": "44\"",
          "w": 44,
          "l": 44,
          "shape": "round",
          "handle": "largo-front-lighted-44x44",
          "vid": "40834442788973",
          "qty": 13
        }
      ],
      "1PC": [
        {
          "label": "24\"",
          "w": 24,
          "l": 24,
          "shape": "round",
          "handle": "largo-front-lighted-24x24-1pc",
          "vid": "45075622264941",
          "qty": 2
        },
        {
          "label": "32\"",
          "w": 32,
          "l": 32,
          "shape": "round",
          "handle": "largo-front-lighted-32x32-1pc",
          "vid": "41758456250477",
          "qty": 4
        },
        {
          "label": "48\"",
          "w": 48,
          "l": 48,
          "shape": "round",
          "handle": "largo-front-lighted-48x48-1pc",
          "vid": "45075622396013",
          "qty": 6
        }
      ]
    },
    "Lakeland": {
      "2PC": [
        {
          "label": "24\"",
          "w": 24,
          "l": 24,
          "shape": "round",
          "handle": "side-lighted-led-bathroom-vanity-mirror-24-x-24-round-wall-mounted",
          "vid": "40834453209197",
          "qty": 0
        },
        {
          "label": "36\"",
          "w": 36,
          "l": 36,
          "shape": "round",
          "handle": "side-lighted-led-bathroom-vanity-mirror-36-x-36-round-wall-mounted",
          "vid": "40834458812525",
          "qty": 0
        },
        {
          "label": "40\"",
          "w": 40,
          "l": 40,
          "shape": "round",
          "handle": "lakeland-side-lighted-40x40",
          "vid": "45355187241069",
          "qty": 9
        },
        {
          "label": "44\"",
          "w": 44,
          "l": 44,
          "shape": "round",
          "handle": "lakeland-side-lighted-44x44",
          "vid": "45355187732589",
          "qty": 13
        }
      ],
      "1PC": [
        {
          "label": "24\"",
          "w": 24,
          "l": 24,
          "shape": "round",
          "handle": "lakeland-side-lighted-24x24-1pc",
          "vid": "45355185799277",
          "qty": 11
        },
        {
          "label": "36\"",
          "w": 36,
          "l": 36,
          "shape": "round",
          "handle": "lakeland-side-lighted-36x36-1pc",
          "vid": "45355186946157",
          "qty": 4
        },
        {
          "label": "48\"",
          "w": 48,
          "l": 48,
          "shape": "round",
          "handle": "lakeland-side-lighted-48x48-1pc",
          "vid": "45355188322413",
          "qty": 5
        }
      ]
    },
    "Linden": {
      "2PC": [
        {
          "label": "24\" × 32\"",
          "w": 24,
          "l": 32,
          "shape": "oval",
          "handle": "linden-front-lighted-24x32",
          "vid": "45355188846701",
          "qty": 16
        },
        {
          "label": "30\" × 36\"",
          "w": 30,
          "l": 36,
          "shape": "oval",
          "handle": "front-lighted-led-bathroom-vanity-mirror-30-x-36-oval-wall-mounted",
          "vid": "40834475851885",
          "qty": 1
        }
      ],
      "1PC": [
        {
          "label": "24\" × 32\"",
          "w": 24,
          "l": 32,
          "shape": "oval",
          "handle": "linden-front-lighted-24x32-1pc",
          "vid": "45355189108845",
          "qty": 38
        },
        {
          "label": "30\" × 36\"",
          "w": 30,
          "l": 36,
          "shape": "oval",
          "handle": "linden-30x36-13do",
          "vid": "45355189207149",
          "qty": 9
        }
      ]
    },
    "Laurel": {
      "2PC": [
        {
          "label": "20\" × 28\"",
          "w": 20,
          "l": 28,
          "shape": "oval",
          "handle": "copy-of-side-lit-led-bathroom-mirror-20-x-28-oval-2pc",
          "vid": "40834482503789",
          "qty": 0
        },
        {
          "label": "30\" × 36\"",
          "w": 30,
          "l": 36,
          "shape": "oval",
          "handle": "side-lighted-led-bathroom-vanity-mirror-30-x-36-oval-wall-mounted",
          "vid": "40834491744365",
          "qty": 2
        },
        {
          "label": "32\" × 40\"",
          "w": 32,
          "l": 40,
          "shape": "oval",
          "handle": "laurel-side-lighted-32x40",
          "vid": "45355189403757",
          "qty": 25
        }
      ],
      "1PC": [
        {
          "label": "24\" × 32\"",
          "w": 24,
          "l": 32,
          "shape": "oval",
          "handle": "laurel-side-lighted-24x32-1pc",
          "vid": "45355189338221",
          "qty": 16
        }
      ]
    }
  }
};
